import React from 'react'
import { LinkButton } from './styles'

function SchemaCell({ name }) {
  if (!name) return <>Не задана</>
  return (
    <LinkButton to={`/admin/schemas/${name}/`}>
      {name}
    </LinkButton>
  )
}

export default SchemaCell
